import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/common/ConfirmationModal/ConfirmationModal";
import Connectpayment from "./Connect-payment";
import SidebarContext from "../../../context/SidebarContext";
import Legalcomponet from "./Legalcomponet";

export default function PaymentViewInstruction({
  checkHeader,
  checkbtn,
}) {
  const [stripeKey, setStripeKey] = useState("");
  const [connected, setConnected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
    adminId: "",
  });

  const ConnectStripe = () => {
    if (stripeKey) {
      setConnected(true);
      toast.success("Your Stripe account is connected successfully.");
    }
  };

  const deleteHandler = async () => {
    setLoading(true);
    setConnected(false);
    setStripeKey("");
    setConfirmationModalState({ showModal: false, adminId: "" });
    setLoading(false);
  };

  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false, dealId: "" });
  };
  const { open } = useContext(SidebarContext);
  return (
    <>
      <Box>
        <Connectpayment
          checkHeader={checkHeader}
          checkbtn={checkbtn}
        />
      </Box>
      <ConfirmationModal
        showModal={confirmatioModalState.showModal}
        submitHandler={() => deleteHandler()}
        submitText={"Confirm Disconnect"}
        cancelText={"Cancel"}
        cancelHandler={cancelHandler}
        headerText={"Are you sure you want to disconnect your Stripe account?"}
        bodyText={
          "You will not be able to receive payments through POSTPAL after disconnecting."
        }
      />
    </>
  );
}
